import React, { useContext, useEffect, useState } from 'react'
import { Close, OfflinePinOutlined, Toll } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import { BufferService, LoadingContext, M_Button, M_Fieldset, M_Header, M_Select, M_SimpleTable, M_TabsInpage } from 'src/M_Components'
import { useMediaQuery } from '@mui/material'

export const ChargeRulesCrud = ({ handleTabClose }) => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const [tabs, setTabs] = useState(1)
    const [data, setData] = useState({})
    const [operation, setOperation] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [mainOperand, setMainOperand] = useState('AND')
    const viewChargeRuleService = new BufferService('viewchargerule')

    const matches = useMediaQuery('(min-width:1500px)')
    // const matches2 = useMediaQuery('(min-width:1760px)')
    const matches3 = useMediaQuery('(min-width:1250px)')
    const matches4 = useMediaQuery('(min-width:1150px)')
    const matches5 = useMediaQuery('(min-width:850px)')
    const matches55 = useMediaQuery('(min-width:780px)')
    const matches6 = useMediaQuery('(min-width:720px)')
    const matches66 = useMediaQuery('(min-width:680px)')
    const matches7 = useMediaQuery('(min-width:550px)')
    const matches8 = useMediaQuery('(min-width:430px)')

    const sessionKeys = ['operation', 'data', 'tabs']


    const QuoteChargeFields = [
        { display: t('Name'), required: true, code: 'name', type: 'text' },
        { display: t('Priority'), required: false, code: 'priority', type: 'number' },
        { display: t('ServiceCode'), required: true, code: 'serviceCode', type: 'foreignKey', entity: 'ServiceType', filterField: 'ServiceCode', labelFields: ['ServiceCode'], fields: [{ key: 'ServiceCode', value: 'serviceCode' }, { key: 'Id', value: 'serviceId' }], },
        { display: t('Value'), required: false, code: 'chargeValue', type: 'number' },
        { display: t('Currency'), required: false, code: 'currencyCode', type: 'foreignKey', entity: 'Currency', filterField: 'code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'currencyCode' }, { key: 'Id', value: 'currencyId' }], },
        { display: t('Quantity'), required: false, code: 'quantity', type: 'number' },
        { display: t('Multiple'), required: false, code: 'multiple', type: 'select', options: 'multipleOptions', extraField: 'multipleValue' },
        { display: t('ExchangeRate'), required: false, code: 'exchangeRate', type: 'select', options: 'exchangeRateOptions', extraField: 'exchangeRateValue' },
        { display: t('Description'), required: false, code: 'description', type: 'text' },
    ]

    const CostFields = [
        { display: t('Value'), required: false, code: 'costValue', type: 'number' },
        { display: t('Supplier'), required: false, code: 'supplierCode', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'supplierCode' }, { key: 'Id', value: 'supplierId' }], },
        { display: t('Currency'), required: false, code: 'costCurrencyCode', type: 'foreignKey', entity: 'Currency', filterField: 'code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'costCurrencyCode' }, { key: 'Id', value: 'costCurrencyId' }], },
        { display: t('ExchangeRate'), required: false, code: 'costExchangeRate', type: 'select', options: 'exchangeRateOptions', extraField: 'costExchangeRateValue' },
    ]

    const ManifestFields = [
        { display: t('Value'), required: false, code: 'manifestValue', type: 'number' },
        { display: t('Multiple'), required: false, code: 'manifestMultiple', type: 'select', options: 'multipleOptions', extraField: 'manifestMultipleValue' },
        { display: t('Currency'), required: false, code: 'manifestCurrencyCode', type: 'foreignKey', entity: 'Currency', filterField: 'code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'manifestCurrencyCode' }, { key: 'Id', value: 'manifestCurrencyId' }], },
    ]

    const RestrictionsFields = [
        { display: t('EquipmentType'), required: false, code: 'restrictionsEquipmentType', type: 'foreignKey', entity: 'equipmentType', filterField: 'EquipmentTypeCode', labelFields: ['EquipmentTypeLenght', 'EquipmentTypeCode'], fields: [{ key: 'EquipmentTypeLenght', value: 'restrictionsSize' }, { key: 'EquipmentTypeCode', value: 'restrictionsEquipmentType' }, { key: 'Id', value: 'restrictionsEquipmentTypeId' }], },
    ]

    const DetailsFields = [
        { display: t('PayingCompany'), required: false, code: 'payingCompany', type: 'select', options: 'payingCompanyOptions', extraField: 'payingCompanyValue' },
        { display: t('LumpSum'), required: false, code: 'lumpSumCode', type: 'foreignKey', entity: 'LumpSum', filterField: 'code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'lumpSumCode' }, { key: 'Id', value: 'lumpSumId' }], },
        { display: t('PayableHow'), required: false, code: 'payableHow', type: 'select', options: 'payableHowOptions', extraField: 'payableHowValue' },

    ]

    const ConditionsFields = [
        { display: t('Condition'), required: false, code: 'condition', type: 'select', options: 'conditionOptions', extraField: 'conditionValue' },
        { display: t('Operation'), required: false, code: 'operation', type: 'select', options: 'operationOptions', extraField: 'operationValue' },
        { display: t('Value'), required: false, code: 'value', type: 'number' },
        { display: t('Group'), required: false, code: 'group', type: 'select', options: 'groupOptions', extraField: 'groupValue' },
        { type: matches && 'whitespace' || '' },
        { type: matches && 'whitespace' || '' },
        { type: 'whitespace' },
    ]

    const multipleOptions = [
        { label: t('Equipment'), value: 'equipment', apiLabel: 'Equipment', dbValue: 'E' },
        { label: t('Document'), value: 'document', apiLabel: 'Document', dbValue: 'D' },
        { label: t('Process'), value: 'process', apiLabel: 'Process', dbValue: 'P' },
        { label: t('Weight'), value: 'weight', apiLabel: 'Weight', dbValue: 'W' },
        { label: t('Measures'), value: 'measure', apiLabel: 'Measures', dbValue: 'M' },
        { label: t('Percentage'), value: 'percentage', apiLabel: 'Percentage', dbValue: 'C' },
        { label: t('Other'), value: 'other', apiLabel: 'Other', dbValue: 'O' },
        { label: t('TEU'), value: 'teu', apiLabel: 'TEU', dbValue: 'T' },
        { label: t('Quantity'), value: 'quantity', apiLabel: 'Quantity', dbValue: 'Q' },
        { label: t('KG 6 DM3'), value: 'kg6dm3', apiLabel: 'KG 6 DM3', dbValue: 'G' },
        { label: t('KG'), value: 'kg', apiLabel: 'K6', dbValue: 'K' },
    ]

    const exchangeRateOptions = [
        { label: t('Sale'), value: 'sale', apiLabel: 'Sale', dbValue: 'S' },
        { label: t('Average'), value: 'average', apiLabel: 'Average', dbValue: 'A' },
        { label: t('Buy'), value: 'buy', apiLabel: 'Buy', dbValue: 'B' },
    ]

    const payingCompanyOptions = [
        { label: t('Client'), value: 'client', apiLabel: 'Client', dbValue: 'C' },
        { label: t('Other - Foreign Currency'), value: 'foreign', apiLabel: 'Other - Foreign Currency', dbValue: 'E' },
        { label: t('Invoice'), value: 'invoice', apiLabel: 'Invoice', dbValue: 'I' },
        { label: t('Shipper'), value: 'shipper', apiLabel: 'Shipper', dbValue: 'S' },
        { label: t('Consignee'), value: 'consignee', apiLabel: 'Consignee', dbValue: 'G' },
        { label: t('Notify'), value: 'notify', apiLabel: 'Notify', dbValue: 'N' },
        { label: t('Agent'), value: 'agent', apiLabel: 'Agent', dbValue: 'A' },
        { label: t('Feeder'), value: 'feeder', apiLabel: 'Feeder', dbValue: 'F' },
        { label: t('Other'), value: 'other', apiLabel: 'Other', dbValue: 'O' },
    ]

    const payableHowOptions = [
        { label: t('Prepaid'), value: 'prepaid', apiLabel: 'Prepaid', dbValue: 'P' },
        { label: t('Collect'), value: 'collect', apiLabel: 'Collect', dbValue: 'C' },
        { label: t('Prep. Else'), value: 'prepElse', apiLabel: 'Prep. Else', dbValue: 'Q' },
        { label: t('Coll. Else'), value: 'collElse', apiLabel: 'Coll. Else', dbValue: 'D' },
        { label: t('Other'), value: 'other', apiLabel: 'Other', dbValue: 'O' },
        { label: t('BLANK'), value: 'blank', apiLabel: null, dbValue: '' },
        { label: t('Payable At Dest.'), value: 'payDesc', apiLabel: null, dbValue: 'A' },
    ]

    const operandOptions = [
        { label: t('AND'), value: 'AND' },
        { label: t('OR'), value: 'OR' },
    ]

    const operationOptions = [
        { label: t('Equals'), value: 'equals' },
        { label: t('NotEquals'), value: 'notEquals' },
        // { label: t('Greater'), value: 'greater' },
        // { label: t('Smaller'), value: 'smaller' },
    ]
    const groupOptions = [
        { label: t('New'), value: 'new' },
    ]

    const conditionOptions = [
        { id: 1, label: t('Size'), value: 'size' },
        { id: 2, label: t('EquipmentType'), value: 'equipmentType' },
        { id: 3, label: t('CommodityCode'), value: 'commodityCode' },
        { id: 4, label: t('CommodityName'), value: 'commodityName' },
        { id: 5, label: t('UNNo'), value: 'unNo' },
        { id: 6, label: t('PackingGroup'), value: 'packingGroup' },
        { id: 7, label: t('GrossWeight'), value: 'grossWeight' },
        { id: 8, label: t('OriginalPort'), value: 'originalPort' },
        { id: 9, label: t('LoadingPort'), value: 'originalPort' },
        { id: 10, label: t('DischargePort'), value: 'originalPort' },
        { id: 11, label: t('FinalPort'), value: 'originalPort' },
        { id: 12, label: t('Client'), value: 'client' },
        { id: 13, label: t('Shipper'), value: 'shipper' },
        { id: 14, label: t('Consignee'), value: 'consignee' },
    ]

    const conditionValueField = [
        { id: 1, display: t('Size'), code: 'value', type: 'number' },
        { id: 2, display: t('EquipmentType'), required: false, code: 'value', type: 'foreignKey', entity: 'equipmentType', filterField: 'EquipmentTypeCode', labelFields: ['EquipmentTypeCode'], fields: [{ key: 'EquipmentTypeCode', value: 'value' }, { key: 'Id', value: 'valueId' }], },
        { id: 3, display: t('CommodityCode'), required: false, code: 'value', type: 'foreignKey', entity: 'Commodity', filterField: 'CommodityCode', labelFields: ['CommodityCode'], fields: [{ key: 'CommodityCode', value: 'value' }, { key: 'Id', value: 'valueId' }], },
        { id: 4, display: t('CommodityName'), required: false, code: 'value', type: 'foreignKey', entity: 'Commodity', filterField: 'CommodityName', labelFields: ['CommodityName'], fields: [{ key: 'CommodityName', value: 'value' }, { key: 'Id', value: 'valueId' }], },
        { id: 5, display: t('UNNo'), code: 'value', type: 'foreignKey', entity: 'DangerousGoods', filterField: 'Code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'value' }, { key: 'Id', value: 'valueId' }], },
        { id: 6, display: t('PackingGroup'), code: 'value', type: 'number' },
        { id: 7, display: t('GrossWeight'), code: 'value', type: 'number' },
        { id: 8, display: t('OriginalPort'), required: true, code: 'value', type: 'foreignKey', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationName'], fields: [{ key: 'LocationName', value: 'value' }, { key: 'Id', value: 'valueId' }], },
        { id: 9, display: t('LoadingPort'), required: true, code: 'value', type: 'foreignKey', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationName'], fields: [{ key: 'LocationName', value: 'value' }, { key: 'Id', value: 'valueId' }], },
        { id: 10, display: t('DischargePort'), required: true, code: 'value', type: 'foreignKey', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationName'], fields: [{ key: 'LocationName', value: 'value' }, { key: 'Id', value: 'valueId' }], },
        { id: 11, display: t('FinalPort'), required: true, code: 'value', type: 'foreignKey', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationName'], fields: [{ key: 'LocationName', value: 'value' }, { key: 'Id', value: 'valueId' }], },
        { id: 12, display: t('Client'), required: false, code: 'value', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'value' }, { key: 'Id', value: 'valueId' }], },
        { id: 13, display: t('Shipper'), required: false, code: 'value', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'value' }, { key: 'Id', value: 'valueId' }], },
        { id: 14, display: t('Consignee'), required: false, code: 'value', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'value' }, { key: 'Id', value: 'valueId' }], },
    ]

    const getDbValue = (opts, optionValue) => {
        if (optionValue == null) return null
        const opt = opts.find(o => o.value === optionValue)
        return opt !== undefined ? opt.dbValue : null
    }

    useEffect(() => {
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
        }
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, operation, data, tabs])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
        if (eval(value) instanceof String && eval(value) === '') return
        if (eval(value) instanceof Number && eval(value) === '') return

        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempT = JSON.parse(sessionStorage.getItem(`${sessionID}tabs`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0) || tempT) {
            setOperation(new String(tempO))
            setData(new Object(tempD))
            setTabs(tempT)
            ctx.setIsLoad(false)
            return
        }

        const passData = ctx.passValues
        if (passData?.Operation) {
            const op = passData.Operation
            setOperation(op)
            ctx.setPassValues(null)
            if ((op === 'Edit' || op === 'Copy' || op === 'View') && passData.Row?.Id) {
                loadEdit(passData.Row.Id, op)
            } else {
                get()
            }
        } else {
            get()
        }
    }

    const loadEdit = (recordId, op) => {
        viewChargeRuleService.getId(recordId).then(viewResponse => {
            if (!viewResponse || viewResponse.name === 'AxiosError') {
                ctx.toastMessages('error', '', viewResponse?.response?.data?.Errors || viewResponse?.message || 'Error loading record')
                ctx.setIsLoad(false)
                return
            }
            const cr = viewResponse.ChargeRule
            if (!cr) {
                ctx.toastMessages('error', '', 'Charge Rule not found')
                ctx.setIsLoad(false)
                return
            }

            const findOptByDb = (opts, dbVal) => opts.find(o => o.dbValue === dbVal)
            const multipleOpt = findOptByDb(multipleOptions, cr.Multiple)
            const exchangeOpt = findOptByDb(exchangeRateOptions, cr.ExchangeRate)
            const costExchangeOpt = findOptByDb(exchangeRateOptions, cr.CostExchangeRate)
            const payingOpt = findOptByDb(payingCompanyOptions, cr.PayingCompany)
            const payableOpt = findOptByDb(payableHowOptions, cr.PayableHow)

            const groups = viewResponse.ChargeRuleConditionsGroupsList || []
            const newConditionsList = []
            const newGroupOpts = [{ label: t('New'), value: 'new' }]
            const groupOperands = {}
            let counter = 1
            let maxGroup = 0

            groups.forEach(groupItem => {
                const grp = groupItem.ChargeRuleConditionsGroups
                const groupOrder = grp?.Order || counter
                const operand = grp?.Operand === 0 ? 'AND' : 'OR'
                maxGroup = Math.max(maxGroup, groupOrder)
                newGroupOpts.push({ label: groupOrder.toString(), value: groupOrder })
                groupOperands[`group${groupOrder}`] = operand
                ;(groupItem.ChargeRuleConditions || []).forEach(cond => {
                    newConditionsList.push({
                        group: groupOrder,
                        condition: cond.Field,
                        operation: cond.Operation === 0 ? t('Equals') : t('NotEquals'),
                        operationValue: cond.Operation === 0 ? 'equals' : 'notEquals',
                        value: cond.Value,
                        id: counter++,
                    })
                })
            })

            const editData = {
                ...(op !== 'Copy' && { Id: cr.Id }),
                name: cr.Name,
                priority: cr.Priority,
                description: cr.Description,
                chargeValue: cr.Value,
                quantity: cr.Quantity,
                exchangeRate: exchangeOpt?.label || cr.ExchangeRate,
                exchangeRateValue: exchangeOpt?.value || cr.ExchangeRate,
                costValue: cr.CostValue,
                costExchangeRate: costExchangeOpt?.label || cr.CostExchangeRate,
                costExchangeRateValue: costExchangeOpt?.value || cr.CostExchangeRate,
                manifestValue: cr.ManifestValue,
                restrictionsSize: cr.RestrictionsSize,
                multiple: multipleOpt?.label || cr.Multiple,
                multipleValue: multipleOpt?.value || cr.Multiple,
                manifestMultiple: multipleOpt?.label || cr.Multiple,
                manifestMultipleValue: multipleOpt?.value || cr.Multiple,
                payingCompany: payingOpt?.label || cr.PayingCompany,
                payingCompanyValue: payingOpt?.value || cr.PayingCompany,
                payableHow: payableOpt?.label || cr.PayableHow,
                payableHowValue: payableOpt?.value || cr.PayableHow,
                serviceCode: cr.ServiceTypeCode,
                serviceId: cr.IdService,
                currencyCode: cr.CurrencyCode,
                currencyId: cr.IdCurrency,
                costCurrencyCode: cr.CostCurrencyCode,
                costCurrencyId: cr.IdCostCurrency,
                manifestCurrencyCode: cr.ManifestCurrencyCode,
                manifestCurrencyId: cr.IdManifestCurrency,
                supplierCode: cr.SupplierCode,
                supplierId: cr.IdSupplier,
                restrictionsEquipmentType: cr.EquipmentTypeCode,
                restrictionsEquipmentTypeId: cr.IdRestrictionsEquipmentType,
                lumpSumCode: cr.LumpSumCode,
                lumpSumId: cr.IdLumpSum,
                multipleOptions,
                exchangeRateOptions,
                payingCompanyOptions,
                payableHowOptions,
                operandOptions,
                operationOptions,
                groupOptions: newGroupOpts,
                conditionOptions,
                conditionsList: newConditionsList,
                conditionsGroupCounter: maxGroup + 1,
                conditionsCounter: counter,
                ...groupOperands,
            }
            setData(editData)
            ctx.setIsLoad(false)
        })
    }

    const get = () => {
        changes('multipleOptions', multipleOptions, setData)
        changes('exchangeRateOptions', exchangeRateOptions, setData)
        changes('payingCompanyOptions', payingCompanyOptions, setData)
        changes('payableHowOptions', payableHowOptions, setData)
        changes('operandOptions', operandOptions, setData)
        changes('operationOptions', operationOptions, setData)
        changes('groupOptions', groupOptions, setData)
        changes('conditionOptions', conditionOptions, setData)

        ctx.setIsLoad(false)
    }

    const addConditions = () => {

        let counterGroup = data?.conditionsGroupCounter || 1
        let counter = data?.conditionsCounter || 1
        let newObj = {}
        let oldArray = data?.conditionsList || []
        let newArray = []
        let canGoIn = false
        let isIn = false


        newObj['group'] = (data['groupValue'] === 'new' || data['groupValue'] === '' || data['groupValue'] === undefined) && counterGroup || data['groupValue']
        newObj['condition'] = data['condition']
        newObj['operation'] = data['operation']
        newObj['operationValue'] = data['operationValue']
        newObj['value'] = data['value']
        newObj['valueId'] = data['valueId']
        newObj['id'] = counter

        if (data['groupValue'] === 'new' || data['groupValue'] === '' || data['groupValue'] === undefined) {
            let groupOptionsArray = data['groupOptions'] || []
            groupOptionsArray.push({ label: counterGroup.toString(), value: counterGroup },)
            changes('conditionsGroupCounter', counterGroup + 1, setData)
            changes(`group${counterGroup}`, 'OR', setData)
        }

        oldArray.forEach(old => {
            if (old.group === newObj.group) {
                canGoIn = true
            }
            if (canGoIn && !isIn && old.group !== newObj.group) {
                newArray.push(newObj)
                isIn = true
            }
            newArray.push(old)
        })

        if (isIn === false) {
            newArray.push(newObj)
        }

        changes('conditionsList', newArray, setData)


        changes('group', '', setData)
        changes('groupValue', '', setData)
        changes('condition', '', setData)
        changes('operation', '', setData)
        changes('value', '', setData)
        changes('conditionsCounter', counter + 1, setData)
    }

    const groupBody = (row) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', padding: '10px', }}>
                <div style={{ marginRight: '20px' }}>{row['group']}</div>
                <M_Select
                    autocomplete
                    size={'120px'}
                    required={true}
                    options={operandOptions}
                    value={data[`group${row['group']}`] && {
                        label: data[`group${row['group']}`],
                        value: data[`group${row['group']}`]
                    } || null}
                    onChangeValue={(obj) => {
                        changes(`group${row['group']}`, obj && obj.label || '', setData)
                    }}
                    color={!data[`group${row['group']}`] && 'var(--color-red)'}
                    secondColor={!data[`group${row['group']}`] && 'var(--color-red)'}
                />
            </div>
        )
    }

    const body = (row, column) => {
        return (
            <div style={{ display: 'flex', width: '200px' }}>
                {row[column] || ''}
            </div>
        )
    }

    const deleteBody = (row) => {
        const newArray = data['conditionsList'].filter(obj => obj.id !== row.id)
        
        changes('conditionsList', newArray, setData)
    }

    const buildViewRequest = (chargeRuleId) => {
        const conditionsList = data.conditionsList || []
        const groups = {}
        conditionsList.forEach(c => {
            if (!groups[c.group]) groups[c.group] = []
            groups[c.group].push(c)
        })
        const conditionsGroupsList = Object.entries(groups).map(([groupOrder, conditions]) => ({
            ChargeRuleConditionsGroups: {
                IdRule: chargeRuleId || null,
                Operand: (data[`group${groupOrder}`] || 'AND') === 'OR' ? 1 : 0,
                Order: parseInt(groupOrder),
            },
            ChargeRuleConditions: conditions.map(c => ({
                Field: c.condition,
                Operation: (c.operationValue === 'notEquals' || c.operation?.toLowerCase().includes('not')) ? 1 : 0,
                Value: c.value,
            }))
        }))
        return {
            ChargeRule: {
                ...(chargeRuleId ? { Id: chargeRuleId } : {}),
                Name: data.name,
                Priority: data.priority,
                Description: data.description,
                Value: data.chargeValue,
                Quantity: data.quantity,
                ExchangeRate: getDbValue(exchangeRateOptions, data.exchangeRateValue),
                CostValue: data.costValue,
                ManifestValue: data.manifestValue,
                CostExchangeRate: getDbValue(exchangeRateOptions, data.costExchangeRateValue),
                RestrictionsSize: data.restrictionsSize,
                Multiple: getDbValue(multipleOptions, data.manifestMultipleValue ?? data.multipleValue),
                PayingCompany: getDbValue(payingCompanyOptions, data.payingCompanyValue),
                PayableHow: getDbValue(payableHowOptions, data.payableHowValue),
                IdService: data.serviceId || null,
                IdCurrency: data.currencyId || null,
                IdCostCurrency: data.costCurrencyId || null,
                IdManifestCurrency: data.manifestCurrencyId || null,
                IdSupplier: data.supplierId || null,
                IdRestrictionsEquipmentType: data.restrictionsEquipmentTypeId || null,
                IdLumpSum: data.lumpSumId || null,
            },
            ChargeRuleConditionsGroupsList: conditionsGroupsList,
        }
    }

    const onSave = () => {
        ctx.setIsLoad(true)

        const handleError = (response) => {
            ctx.toastMessages('error', '', response?.response?.data?.Errors || response.message)
            ctx.setIsLoad(false)
        }

        if (data.Id) {
            viewChargeRuleService.update(data.Id, buildViewRequest(data.Id)).then(response => {
                if (response.name === 'AxiosError') {
                    handleError(response)
                    return
                }
                ctx.toastMessages('success', '', t('Success'))
                ctx.setIsLoad(false)
                handleTabClose(JSON.parse(id))
            })
        } else {
            viewChargeRuleService.put(buildViewRequest(null)).then(response => {
                if (response.name === 'AxiosError') {
                    handleError(response)
                    return
                }
                ctx.toastMessages('success', '', t('Success'))
                ctx.setIsLoad(false)
                handleTabClose(JSON.parse(id))
            })
        }
    }

    return (
        <div>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Save")}
                            icon={<i className="pi pi-save "></i>}
                            label={t("Save")}
                            onClick={() => onSave()}
                        />
                    </>
                }
            />
            <M_Fieldset
                labelInside
                elements={
                    <>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '10px', }}>
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <h2 style={{ color: ctx.secondaryColor, display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                                    <Toll style={{ marginRight: '5px', fontSize: '30px', }} />
                                    {t("ChargeRules")}
                                </h2>
                            </span>
                            <div style={{ border: `1px solid ${ctx.primaryColor}`, width: '50%' }}></div>
                        </div>
                        <M_TabsInpage
                            type={!matches8 && "tabs" || "buttons"}
                            firstTabOpen={tabs}
                            renderTabs={[{ id: 1, labelTab: t('QuoteCharge') }, { id: 2, labelTab: t('QuoteCondition') }]}
                            onGetTab={(e, tab) => {
                                if (!matches8) {
                                    setTabs(tab.id)
                                } else {
                                    setTabs(e.id)
                                }

                            }}
                        />
                        {tabs === 1 && <div style={{ padding: matches8 && '20px' }}>

                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: !matches7 && 'auto' || !matches5 && 'auto auto' || matches4 && 'auto auto auto auto' || 'auto auto auto',
                                justifyContent: 'space-evenly'
                            }}>
                                {QuoteChargeFields.map((field, index) => {
                                    return <div key={index}>{fields(field, index, data, setData)}</div>
                                })}
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: !matches6 && 'auto' || 'auto auto', margin: matches8 && '30px 20px' }}>
                                <M_Fieldset
                                    labelInside
                                    label={t('Cost')}
                                    elements={
                                        <div style={{ display: 'grid', gridTemplateColumns: matches3 && 'auto auto' || 'auto', justifyContent: 'space-evenly' }}>
                                            {CostFields.map((field, index) => {
                                                return <div key={index}>{fields(field, index, data, setData)}</div>
                                            })}
                                        </div>
                                    }
                                />
                                <M_Fieldset
                                    labelInside
                                    label={t('Manifest')}
                                    elements={
                                        <div style={{ display: 'grid', gridTemplateColumns: matches3 && 'auto auto' || 'auto', justifyContent: 'space-evenly' }}>
                                            {ManifestFields.map((field, index) => {
                                                return <div key={index}>{fields(field, index, data, setData)}</div>
                                            })}
                                        </div>
                                    }
                                />
                                <M_Fieldset
                                    labelInside
                                    label={t('Restrictions')}
                                    elements={
                                        <div style={{ display: 'grid', gridTemplateColumns: matches3 && 'auto auto' || 'auto', justifyContent: 'space-evenly' }}>
                                            {RestrictionsFields.map((field, index) => {
                                                return <div key={index}>{fields(field, index, data, setData)}</div>
                                            })}
                                        </div>
                                    }
                                />
                                <M_Fieldset
                                    labelInside
                                    label={t('Details')}
                                    elements={
                                        <div style={{ display: 'grid', gridTemplateColumns: matches3 && 'auto auto' || 'auto', justifyContent: 'space-evenly' }}>
                                            {DetailsFields.map((field, index) => {
                                                return <div key={index}>{fields(field, index, data, setData)}</div>
                                            })}
                                        </div>
                                    }
                                />
                            </div>
                        </div>}
                        {tabs === 2 && <div style={{ display: 'flex', justifyContent: 'center', }}>
                            <div style={{ width: '75%' }}>
                                <M_Fieldset
                                    labelInside
                                    label={<div style={{ display: 'flex', alignItems: 'center' }}><OfflinePinOutlined style={{ marginRight: '5px', fontSize: '30px', }} />{t('Conditions')}</div>}
                                    headerElement={matches66 &&
                                        <M_Select
                                            autocomplete
                                            size={'150px'}
                                            required={true}
                                            label={t('MainOperand')}
                                            options={operandOptions}
                                            value={operandOptions.find(o => o.value === mainOperand) || null}
                                            onChangeValue={(obj) => setMainOperand(obj?.value || 'AND')}
                                        />
                                    }
                                    elements={
                                        <div>
                                            <div style={{ display: 'grid', gridTemplateColumns: !matches55 && 'auto' || !matches4 && 'auto auto' || !matches && 'auto auto auto' || 'auto auto auto auto', justifyContent: 'space-evenly', marginBottom: '20px' }}>
                                                {!matches66 &&
                                                    <div style={{ marginBottom: '50px' }}>
                                                        <M_Select
                                                            autocomplete
                                                            size={'150px'}
                                                            required={true}
                                                            label={t('MainOperand')}
                                                            options={operandOptions}
                                                            value={operandOptions.find(o => o.value === mainOperand) || null}
                                                            onChangeValue={(obj) => setMainOperand(obj?.value || 'AND')}
                                                        />
                                                    </div>
                                                }
                                                {ConditionsFields.map((field, index) => {
                                                    if (field?.code === 'value' && data?.['condition']) {
                                                        return <div key={index}>{fields(conditionValueField.find(obj => obj.id === conditionOptions.find(obj => obj?.value === data?.['conditionValue']).id), index, data, setData)}</div>
                                                    }
                                                    return <div key={index}>{fields(field, index, data, setData)}</div>
                                                })}
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <M_Button
                                                        normal
                                                        label={t('Add')}
                                                        borderColor={'var(--color-grey)'}
                                                        icon={<img
                                                            src='/icons/svgsDaNet/plus-square.svg'
                                                            alt={t("Add")}
                                                            style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)' }}
                                                            className='iconCreateBooking'
                                                        />}
                                                        onClick={() => addConditions()}
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ padding: '20px' }}>
                                                <M_SimpleTable
                                                    normal={matches4}
                                                    rows={data['conditionsList'] && data['conditionsList'] || []}
                                                    columns={[
                                                        { 'header': t('Group'), 'field': 'group', 'body': (row) => groupBody(row) },
                                                        { 'header': t('Condition'), 'field': 'condition', 'body': (row) => body(row, 'condition') },
                                                        { 'header': t('Operation'), 'field': 'operation', 'body': (row) => body(row, 'operation') },
                                                        { 'header': t('Value'), 'field': 'value', 'body': (row) => body(row, 'value') },
                                                        { 'header': '', 'body': (row) => <div style={{ width: '20px', display: 'flex', justifyContent: 'center' }}><M_Button icon={<Close style={{ color: 'var(--color-red)' }} />} onClick={() => deleteBody(row)} /></div> },
                                                    ]}
                                                    groupField={['group']}

                                                />
                                            </div>
                                        </div>
                                    }
                                />
                            </div>
                        </div>}
                    </>
                }
            />
        </div>
    )
}




